/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import ReactInputMask from "react-input-mask";
import Autocomplete from "react-google-autocomplete";
import { COUNTRIES } from "../../../../../constants/countries";
import {
  onlyAlphaNumeric,
  pasteZipCode,
} from "../../../../../common/Functions";
import InfoTooltip from "../../../../LandingPages/ConfidentialApplication/ConfAppSections/InfoTooltip";
import "./steps.scss";

function StepOne({
  state,
  onBlur,
  onKeyDown,
  handleChange,
  handleSalesChange,
  handleIRBChange,
  handleCurrentlyWorkingChange,
  handleContactEmployerChange,
  handlePhoneChange,
  handleIndustryChange,
  clickFunc,
  onFocus,
  onFocusState,
  handlePlaceSelect,
  onCurrentlyWorkingYesClick,
}) {
  return (
    <>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-12">
          <label htmlFor="title" id="emp_hist_title_label">
            <strong>Title*</strong>
          </label>
          <input
            type="text"
            id="title"
            className={
              state?.title_error ? "form-control is-invalid" : "form-control"
            }
            spellCheck="false"
            maxLength={100}
            autoComplete="new-password"
            value={state.title}
            onBlur={onBlur}
            onChange={handleChange}
            onKeyDown={onKeyDown}
          />
          {state?.title_error && (
            <div id="title_error" className="invalid-feedback">
              Please enter a Title
            </div>
          )}
        </div>
      </div>
      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-12">
          <label htmlFor="company_name" id="emp_hist_company_name_label">
            <strong>Company Name*</strong>
          </label>
          <input
            type="text"
            id="company_name"
            className={`${state?.company_name_error ? "form-control is-invalid" : "form-control"}`}
            spellCheck="false"
            maxLength={100}
            value={state.company_name}
            onBlur={onBlur}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            autoComplete="off"
          />
          {state?.company_name_error && (
            <div id="company_name_error" className="invalid-feedback">
              Please enter a Company Name
            </div>
          )}
        </div>
      </div>

      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-12">
          <label id="emp_hist_industry" htmlFor="industry_select">
            <strong>Industry*</strong>
          </label>
          <DropdownButton
            id="industry_select"
            type="default"
            variant="secondary"
            title={
              <span
                className="ellipsis-overflow"
                title={state.industry_select_desc}
              >
                {state.industry_select_desc}
              </span>
            }
            selected={false}
            autoComplete="new-password"
            onSelect={(key, event) => {
              event.target.id = "industry_select";
              event.target.value = key;
              handleIndustryChange(event);
            }}
            onBlur={onBlur}
            onClick={clickFunc}
            onMouseDown={onKeyDown}
            onFocus={onFocus}
          >
            {state.industry_select_options
              .sort((a, b) => (a.i_industryname < b.i_industryname ? -1 : 1))
              .map((option) => (
                <Dropdown.Item
                  key={option.i_industryid}
                  eventKey={option.i_industryid}
                  id={"industry_option_" + option.i_industryid}
                >
                  {option.i_industryname}
                </Dropdown.Item>
              ))}
          </DropdownButton>
          <div id="industry_select_error" className="invalid-feedback">
            Please choose an Industry
          </div>
        </div>
      </div>

      {/* END */}
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-7">
          <span id="emp_hist_sales_label">
            Is this position in Sales?<strong>*</strong>
          </span>{" "}
          <InfoTooltip
            placement="top"
            text={
              "You will need to answer a few questions related to your sales history on a separate section in this application."
            }
          />
        </div>
        <div className="col-md-2 custom-control custom-radio">
          <input
            type="radio"
            id="sales_yes"
            name="sales"
            className="custom-control-input"
            checked={state.sales === "Y"}
            value="Y"
            onChange={handleSalesChange}
          />
          <label
            htmlFor="sales_yes"
            className="custom-control-label"
            id="label_sales_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="sales_no"
            name="sales"
            className="custom-control-input"
            checked={state.sales === "N"}
            value="N"
            onChange={handleSalesChange}
          />
          <label
            htmlFor="sales_no"
            className="custom-control-label"
            id="label_sales_no"
          >
            No
          </label>
        </div>
      </div>

      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-7">
          <span id="emp_hist_irb_label">
            Is this position in Investment Related Business?
            <strong>*</strong>
          </span>{" "}
        </div>
        <div className="col-md-2 custom-control custom-radio">
          <input
            type="radio"
            id="irb_yes"
            name="irb"
            className="custom-control-input"
            checked={state.irb === "Y"}
            value="Y"
            onChange={handleIRBChange}
          />
          <label
            htmlFor="irb_yes"
            className="custom-control-label"
            id="label_irb_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="irb_no"
            name="irb"
            className="custom-control-input"
            checked={state.irb === "N"}
            value="N"
            onChange={handleIRBChange}
          />
          <label
            htmlFor="irb_no"
            className="custom-control-label"
            id="label_irb_no"
          >
            No
          </label>
        </div>
      </div>

      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-7">
          <span id="emp_hist_currently_working_label">
            I am currently working in this role
            <strong>*</strong>
          </span>
        </div>
        <div className="col-md-2 custom-control custom-radio">
          <input
            type="radio"
            id="currently_working_yes"
            name="currently_working"
            className="custom-control-input"
            checked={state.currently_working === "Y"}
            value="Y"
            onChange={handleCurrentlyWorkingChange}
          />
          <label
            htmlFor="currently_working_yes"
            className="custom-control-label"
            id="label_currently_working_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="currently_working_no"
            name="currently_working"
            className="custom-control-input"
            checked={state.currently_working === "N"}
            value="N"
            onChange={handleCurrentlyWorkingChange}
          />
          <label
            htmlFor="currently_working_no"
            className="custom-control-label"
            id="label_currently_working_no"
          >
            No
          </label>
        </div>
      </div>
      {state.currently_working === "N" && (
        <div className="row" style={{ paddingTop: "10px" }}>
          <div className="col">
            <label id="reasonforleavingText">
              <strong> Reason for leaving? (optional) </strong>
            </label>
            <input
              id={"reason_for_leaving"}
              className="form-control form-control-15"
              value={state.reason_for_leaving}
              onBlur={onBlur}
              onChange={handleChange}
              onKeyDown={onKeyDown}
              minLength={2}
              maxLength={500}
              autoComplete="new-address"
              //onBlur={onBlurAddress2}
            ></input>
            <div id={"reason_for_leaving_error"} className="invalid-feedback">
              Please add a valid reason for leaving
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-6" style={{ marginTop: "10px" }}>
          <label
            htmlFor="employment_start_date"
            id="emp_hist_employment_start_date_label"
          >
            <strong>Start Date*</strong>
          </label>
          <ReactInputMask
            id="employment_start_date"
            mask="99/99/9999"
            maskChar="_"
            className={
              state?.employment_start_date_error
                ? "form-control is-invalid"
                : "form-control"
            }
            placeholder="MM/DD/YYYY"
            autoComplete="new-password"
            value={state.employment_start_date}
            onBlur={onBlur}
            onChange={handleChange}
            onKeyDown={onKeyDown}
          />
          {state?.employment_start_date_error && (
            <div id="employment_start_date_error" className="invalid-feedback">
              {state?.employment_start_date_error_text}
            </div>
          )}
        </div>
        <div className="col-md-6" style={{ marginTop: "10px" }}>
          <label
            htmlFor="employment_end_date"
            id="emp_hist_employment_end_date_label"
          >
            <strong>End Date*</strong>
          </label>
          <ReactInputMask
            id="employment_end_date_display"
            mask="99/99/9999"
            maskChar="_"
            className={
              state?.employment_end_date_error
                ? "form-control is-invalid"
                : "form-control"
            }
            placeholder="MM/DD/YYYY"
            autoComplete="new-password"
            value={state.employment_end_date_display}
            onBlur={onBlur}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            disabled={state.end_date_disabled}
          />
          {state?.employment_end_date_error && (
            <div id="employment_end_date_error" className="invalid-feedback">
              {state?.employment_end_date_error_text}
            </div>
          )}
        </div>
      </div>
      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-12">
          <label htmlFor="street_address" id="emp_hist_street_address_label">
            <strong>Address of Employer*</strong>
          </label>
          <Autocomplete
            apiKey={window.REACT_APP_GOOGLE_API_KEY}
            onPlaceSelected={(place) => {
              handlePlaceSelect(place);
            }}
            options={{
              types: ["geocode", "establishment"],
              componentRestrictions: {
                country: [
                  "us" /*United States*/,
                  //"as" /*American Samoa*/,
                  //"fm" /*Federated States of Micronesia*/,
                  //"gu" /*Guam*/,
                  //"mh" /*Marshall Islands*/,
                  //"mp" /*Northern Mariana Islands*/,
                  "pr" /*Puerto Rico*/,
                  //"pw" /*Palau*/,
                  //"vi" /*U.S. Virgin Islands*/,
                  //"um" /*U.S. Minor Outlying Islands*/,
                ],
              },
            }}
            id={"street_address"}
            className={
              state?.street_address_error
                ? "form-control form-control-15 is-invalid"
                : "form-control form-control-15"
            }
            placeholder="Enter an Address"
            value={state.street_address}
            onChange={handleChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            maxLength={320}
          />
          {state?.street_address_error && (
            <div id="street_address_error" className="invalid-feedback">
              Please enter an Address
            </div>
          )}
        </div>
      </div>
      <div className="row" style={{ paddingTop: "20px" }}>
        <div className="col">
          <label id="address_apartment_code">
            <strong> Apartment, Suite, Building, Gate Code </strong>
          </label>
          <input
            id={"address2"}
            className="form-control form-control-15"
            value={state.address2}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            maxLength={320}
            autoComplete="new-address"
          ></input>
        </div>
      </div>
      <div className="row" style={{ paddingTop: "10px" }}>
        <div className="col-md-12">
          <label id="emp_hist_city_label">
            <strong>City*</strong>
          </label>
          <input
            id="city"
            name="city"
            className={
              state?.city_error ? "form-control is-invalid" : "form-control"
            }
            value={state.city}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            autoComplete="new-address"
            onBlur={onBlur}
            maxLength={320}
          ></input>
          {state?.city_error && (
            <div id="city_error" className="invalid-feedback">
              Please enter a City
            </div>
          )}
        </div>
      </div>
      <div className="row" style={{ paddingTop: "15px" }}>
        <div className="col-md-12">
          <label id="emp_hist_state_label">
            <strong>
              State / Province
              {state.show_state_required === true && "*"}
            </strong>
          </label>
          <DropdownButton
            id="state"
            type="default"
            variant="secondary"
            title={state.state || "\u00A0"}
            selected={false}
            autoComplete="new-address"
            className={state.state_error ? "is-invalid" : ""}
            onSelect={(key, event) => {
              event.target.id = "state";
              event.target.value = key;
              handleChange(event);
              onKeyDown();
            }}
            onBlur={onBlur}
            onClick={clickFunc}
            onFocus={onFocusState}
          >
            <Dropdown.Item eventKey={""} id="state_option"></Dropdown.Item>
            <Dropdown.Item eventKey={"PR"} id="state_option_PR">
              PR - Puerto Rico
            </Dropdown.Item>
            <Dropdown.Item eventKey={"AL"} id="state_option_AL">
              AL - Alabama
            </Dropdown.Item>
            <Dropdown.Item eventKey={"AK"} id="state_option_AK">
              AK - Alaska
            </Dropdown.Item>
            <Dropdown.Item eventKey={"AZ"} id="state_option_AZ">
              AZ - Arizona
            </Dropdown.Item>
            <Dropdown.Item eventKey={"AR"} id="state_option_AR">
              AR - Arkansas
            </Dropdown.Item>
            <Dropdown.Item eventKey={"CA"} id="state_option_CA">
              CA - California
            </Dropdown.Item>
            <Dropdown.Item eventKey={"CO"} id="state_option_CO">
              CO - Colorodo
            </Dropdown.Item>
            <Dropdown.Item eventKey={"CT"} id="state_option_CT">
              CT - Connecticut
            </Dropdown.Item>
            <Dropdown.Item eventKey={"DE"} id="state_option_DE">
              DE - Delaware
            </Dropdown.Item>
            <Dropdown.Item eventKey={"DC"} id="state_option_DC">
              DC - District of Columbia
            </Dropdown.Item>
            <Dropdown.Item eventKey={"FL"} id="state_option_FL">
              FL - Florida
            </Dropdown.Item>
            <Dropdown.Item eventKey={"GA"} id="state_option_GA">
              GA - Georgia
            </Dropdown.Item>
            <Dropdown.Item eventKey={"HI"} id="state_option_HI">
              HI - Hawaii
            </Dropdown.Item>
            <Dropdown.Item eventKey={"ID"} id="state_option_ID">
              ID - Idaho
            </Dropdown.Item>
            <Dropdown.Item eventKey={"IL"} id="state_option_IL">
              IL - Illinois
            </Dropdown.Item>
            <Dropdown.Item eventKey={"IN"} id="state_option_IN">
              IN - Indiana
            </Dropdown.Item>
            <Dropdown.Item eventKey={"IA"} id="state_option_IA">
              IA - Iowa
            </Dropdown.Item>
            <Dropdown.Item eventKey={"KS"} id="state_option_KS">
              KS - Kansas
            </Dropdown.Item>
            <Dropdown.Item eventKey={"KY"} id="state_option_KY">
              KY - Kentucky
            </Dropdown.Item>
            <Dropdown.Item eventKey={"LA"} id="state_option_LA">
              LA - Louisiana
            </Dropdown.Item>
            <Dropdown.Item eventKey={"ME"} id="state_option_ME">
              ME - Maine
            </Dropdown.Item>
            <Dropdown.Item eventKey={"MD"} id="state_option_MD">
              MD - Maryland
            </Dropdown.Item>
            <Dropdown.Item eventKey={"MA"} id="state_option_MA">
              MA - Massachusetts
            </Dropdown.Item>
            <Dropdown.Item eventKey={"MI"} id="state_option_MI">
              MI - Michigan
            </Dropdown.Item>
            <Dropdown.Item eventKey={"MN"} id="state_option_MN">
              MN - Minnesota
            </Dropdown.Item>
            <Dropdown.Item eventKey={"MS"} id="state_option_MS">
              MS - Mississippi
            </Dropdown.Item>
            <Dropdown.Item eventKey={"MO"} id="state_option_MO">
              MO - Missouri
            </Dropdown.Item>
            <Dropdown.Item eventKey={"MT"} id="state_option_MT">
              MT - Montana
            </Dropdown.Item>
            <Dropdown.Item eventKey={"NE"} id="state_option_NE">
              NE - Nebraska
            </Dropdown.Item>
            <Dropdown.Item eventKey={"NV"} id="state_option_NV">
              NV - Nevada
            </Dropdown.Item>
            <Dropdown.Item eventKey={"NH"} id="state_option_NH">
              NH - New Hampshire
            </Dropdown.Item>
            <Dropdown.Item eventKey={"NJ"} id="state_option_NJ">
              NJ - New Jersey
            </Dropdown.Item>
            <Dropdown.Item eventKey={"NM"} id="state_option_NM">
              NM - New Mexico
            </Dropdown.Item>
            <Dropdown.Item eventKey={"NY"} id="state_option_NY">
              NY - New York
            </Dropdown.Item>
            <Dropdown.Item eventKey={"NC"} id="state_option_NC">
              NC - North Carolina
            </Dropdown.Item>
            <Dropdown.Item eventKey={"ND"} id="state_option_ND">
              ND - North Dakota
            </Dropdown.Item>
            <Dropdown.Item eventKey={"OH"} id="state_option_OH">
              OH - Ohio
            </Dropdown.Item>
            <Dropdown.Item eventKey={"OK"} id="state_option_OK">
              OK - Oklahoma
            </Dropdown.Item>
            <Dropdown.Item eventKey={"OR"} id="state_option_OR">
              OR - Oregon
            </Dropdown.Item>
            <Dropdown.Item eventKey={"PA"} id="state_option_PA">
              PA - Pennsylvania
            </Dropdown.Item>
            <Dropdown.Item eventKey={"RI"} id="state_option_RI">
              RI - Rhode Island
            </Dropdown.Item>
            <Dropdown.Item eventKey={"SC"} id="state_option_SC">
              SC - South Carolina
            </Dropdown.Item>
            <Dropdown.Item eventKey={"SD"} id="state_option_SD">
              SD - South Dakota
            </Dropdown.Item>
            <Dropdown.Item eventKey={"TN"} id="state_option_TN">
              TN - Tennessee
            </Dropdown.Item>
            <Dropdown.Item eventKey={"TX"} id="state_option_TX">
              TX - Texas
            </Dropdown.Item>
            <Dropdown.Item eventKey={"UT"} id="state_option_UT">
              UT - Utah
            </Dropdown.Item>
            <Dropdown.Item eventKey={"VT"} id="state_option_VT">
              VT - Vermont
            </Dropdown.Item>
            <Dropdown.Item eventKey={"VA"} id="state_option_VA">
              VA - Virginia
            </Dropdown.Item>
            <Dropdown.Item eventKey={"WA"} id="state_option_WA">
              WA - Washington
            </Dropdown.Item>
            <Dropdown.Item eventKey={"WV"} id="state_option_WV">
              WV - West Virginia
            </Dropdown.Item>
            <Dropdown.Item eventKey={"WI"} id="state_option_WI">
              WI - Wisconsin
            </Dropdown.Item>
            <Dropdown.Item eventKey={"WY"} id="state_option_WY">
              WY - Wyoming
            </Dropdown.Item>
          </DropdownButton>
          {state.state_error && (
            <div id="state_error" className="invalid-feedback">
              Please select a valid State/Province
            </div>
          )}
        </div>
      </div>
      <div className="row" style={{ paddingTop: "20px" }}>
        <div className="col-md-12">
          <label id="emp_hist_zip_code_label">
            <strong> ZIP Code* </strong>
          </label>
          <input
            id="zip_code"
            className={
              state.zip_code_error ? "form-control is-invalid" : "form-control"
            }
            value={state.zip_code}
            onChange={handleChange}
            autoComplete="new-address"
            onBlur={onBlur}
            maxLength={10}
            onKeyPress={onlyAlphaNumeric}
            onPaste={pasteZipCode}
          ></input>
          {state.zip_code_error && (
            <div id="zip_code_error" className="invalid-feedback">
              Please enter a Zip Code
            </div>
          )}
        </div>
      </div>
      <div className="row" style={{ paddingTop: "15px" }}>
        <div className="col-md-12">
          <label id="emp_hist_country_label">
            <strong>Country*</strong>
          </label>
          <DropdownButton
            id="country"
            type="default"
            variant="secondary"
            title={state.country || "\u00A0"}
            selected={false}
            autoComplete="new-address"
            className={state.country_error ? "is-invalid" : ""}
            onSelect={(key, event) => {
              event.target.id = "country";
              event.target.value = key;
              handleChange(event);
              onKeyDown();
            }}
            onBlur={onBlur}
            onClick={clickFunc}
            onFocus={onFocusState}
          >
            {COUNTRIES.map((option) => (
              <Dropdown.Item
                key={option.code}
                eventKey={option.code}
                id="country_option"
              >
                {option.code + " - " + option.name}
              </Dropdown.Item>
            ))}
          </DropdownButton>
          {state.country_error && (
            <div id="country_error" className="invalid-feedback">
              Please choose a Country
            </div>
          )}
        </div>
      </div>
      {state.showUrbanization === true && (
        <div className="row" style={{ paddingTop: "20px" }}>
          <div className="col">
            <label id="address_urbanization">
              <strong> Urbanization </strong>
            </label>
            <input
              id={"urbanization"}
              type="text"
              className="form-control form-control-15"
              value={state.urbanization}
              onChange={handleChange}
              onKeyDown={onKeyDown}
              onBlur={onBlur}
              autoComplete="new-address"
              placeholder="Puerto Rico Residents Only"
              maxLength={100}
            ></input>
          </div>
        </div>
      )}
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-7">
          <span id="emp_hist_may_we_contact_label">
            May we contact this employer?
            <strong>*</strong>
          </span>
        </div>
        <div className="col-md-2 custom-control custom-radio">
          <input
            type="radio"
            id="contact_employer_yes"
            name="contact_employer"
            className="custom-control-input"
            checked={state.contact_employer === "Y"}
            value="Y"
            onChange={handleContactEmployerChange}
          />
          <label
            htmlFor="contact_employer_yes"
            className="custom-control-label"
            id="label_contact_employer_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="contact_employer_no"
            name="contact_employer"
            className="custom-control-input"
            checked={state.contact_employer === "N"}
            value="N"
            onChange={handleContactEmployerChange}
          />
          <label
            htmlFor="contact_employer_no"
            className="custom-control-label"
            id="label_contact_employer_no"
          >
            No
          </label>
        </div>
      </div>
      {state.may_we_contact_employer && (
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12">
            <label htmlFor="contact_phone" id="emp_hist_contact_phone_label">
              <strong>Phone number of Contact*</strong>
            </label>
            <PhoneInput
              id="contact_phone"
              defaultCountry="US"
              international
              countrySelectProps={{ unicodeFlags: true }}
              autoComplete="new-password"
              className={state.contact_phone_error ? "is-invalid" : ""}
              value={state.contact_phone}
              onBlur={onBlur}
              onChange={handlePhoneChange}
              onKeyDown={onKeyDown}
              maxLength={17}
            />
            {state.contact_phone_error && (
              <div id="contact_phone_error" className="invalid-feedback">
                Please enter Phone number of Contact
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default StepOne;
